import { Helpers } from '../../helpers';
import { IForecastRatioFluidType } from '../../interfaces/iforecast-ratio-fluid-type';
import { ForecastParameterDetail } from '../forecast-parameter-detail';
import { TypeCurveParameter } from '../type-curve-parameter';

export class ForecastRatioFluidTypeBase {
  ForecastRatioFluidTypeId: number;
  Name: string;
  UpdatedBy: string;
  Created: Date;
  Updated: Date;
  CreatedBy: string;

  ForecastParameterDetails_ForecastRatioFluidType?: Array<ForecastParameterDetail> | null;
  TypeCurveParameters_ForecastRatioFluidType?: Array<TypeCurveParameter> | null;

  constructor(item?: IForecastRatioFluidType) {
    if (item) {

      this.ForecastRatioFluidTypeId = item.ForecastRatioFluidTypeId;
      this.Name = item.Name;
      this.UpdatedBy = item.UpdatedBy;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;

      this.ForecastParameterDetails_ForecastRatioFluidType = Helpers.createClassArray(ForecastParameterDetail, item.ForecastParameterDetails_ForecastRatioFluidType);
      this.TypeCurveParameters_ForecastRatioFluidType = Helpers.createClassArray(TypeCurveParameter, item.TypeCurveParameters_ForecastRatioFluidType);
    }
  }
}